
















import { Component, Vue, Watch } from 'vue-property-decorator';
import VueRouter from 'vue-router';
import SearchIcon from 'mdi-vue/Magnify';
import AddIcon from 'mdi-vue/Plus';
import Select from '@/components/Select.vue';
import FormInput from '@/components/FormInput.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Tab from '@/components/Tab/Tab.vue';
import FilterManagement from './components/Filter/UserList.vue';
import FilterRole from './components/Filter/UserRole.vue';

Vue.use(VueRouter);

interface PermissionApiResponse {
  data: PermissionItem[];
}

@Component({
  components: {
    LayoutTitle,
    Select,
    FormInput,
    SearchIcon,
    LayoutContent,
    Button,
    AddIcon,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    FilterManagement,
    FilterRole,
    Loader,
    Tab,
  },
})
export default class UserManagement extends Vue {
  name?: string | null = '';
  tabs = [{
    label: 'User Role List',
    to: 'roles',
  }, {
    label: 'User List',
    to: 'users',
  }];

  get type() {
    return this.$route.params.type;
  }

  @Watch('$route')
  onRouteChange() {
    this.name = this.$route.name;
  }

  mounted() {
    this.name = this.$route.name;

    const isInternal = JSON.parse(localStorage.getItem('USER') || '{}').user.is_internal;
    if (isInternal === 0) {
      this.tabs.shift();
      this.$router.push('/setting/user-management/external/users');
      this.name = 'UserList';
    }
  }
}
